import noop from 'lodash/noop';
import React, { ReactNode, createContext, useState } from 'react';

interface Props {
  children: ReactNode | ReactNode[];
}
interface ContextProps {
  scrollDepth: number;
  screenWidth: number;
  cardIndex: number;
  setScrollDetails: (id: number, screenWidth: number, cardIndex: number) => void;
}

export const NavigationContext = createContext<ContextProps>({
  scrollDepth: 0,
  screenWidth: 0,
  cardIndex: 0,
  setScrollDetails: noop,
});

export const NavigationProvider: React.FC<Props> = ({ children }) => {
  const [scrollDepth, setScrollDepth] = useState<number>(0);
  const [screenWidth, setScreenWidth] = useState<number>(0);
  const [cardIndex, setCardIndex] = useState<number>(0);

  const setScrollDetails = (depth: number, screenWidth: number, cardIndex: number) => {
    setScrollDepth(depth);
    setScreenWidth(screenWidth);
    setCardIndex(cardIndex);
  };

  return (
    <NavigationContext.Provider value={{ scrollDepth, setScrollDetails, screenWidth, cardIndex }}>
      {children}
    </NavigationContext.Provider>
  );
};

export default NavigationContext;
